import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["colorScheme", "details", "disabled", "error", "titleText"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { buildDataTestProps, withTestAttributes } from "../../utils";
import CheckboxSvg from "../checkbox/CheckboxSvg";
import { sharedCheckboxPropTypes } from "../checkbox/propTypes";
import DetailedBox from "../detailed-box/DetailedBox";
import { InputHidden, WrapperLabel } from "../detailed-box/helperComponents";
import { CheckboxColorScheme } from "../";
import { getBackgroundColor, getCheckedBorderColor, getCheckedTextColor, getFocusColor, getHoverColor, getTickWrapperColor } from "../utils";
import Tick from "./Tick";
import { jsx as ___EmotionJSX } from "@emotion/core";
var dataTestComponentName = 'StencilDetailedCheckbox';

var getTickStyles = function getTickStyles(_ref) {
  var checked = _ref.checked,
      getColorParams = _ref.getColorParams,
      state = _ref.state;
  var tickWrapperColor = getTickWrapperColor(getColorParams);

  switch (state) {
    case 'active':
      {
        var checkedTextColor = getCheckedTextColor(getColorParams);
        var hoverColor = getHoverColor(getColorParams);
        return {
          '.detailedCheckboxTick': {
            backgroundColor: tickWrapperColor,
            borderColor: checked ? checkedTextColor : hoverColor
          }
        };
      }

    case 'focus':
      {
        var backgroundColor = getBackgroundColor(getColorParams);
        var focusColor = getFocusColor(getColorParams);
        return {
          '.detailedCheckboxTick': _objectSpread({
            backgroundColor: tickWrapperColor,
            borderColor: checked ? backgroundColor : focusColor
          }, checked ? {
            '.tick': {
              stroke: focusColor
            }
          } : {})
        };
      }

    case 'hover':
      {
        var _backgroundColor = getBackgroundColor(getColorParams);

        var _hoverColor = getHoverColor(getColorParams);

        return {
          '.detailedCheckboxTick': _objectSpread({
            backgroundColor: tickWrapperColor,
            borderColor: checked ? _backgroundColor : _hoverColor
          }, checked ? {
            '.tick': {
              stroke: _hoverColor
            }
          } : {})
        };
      }

    default:
      if (checked) {
        var checkedColor = getCheckedBorderColor(getColorParams);
        return {
          '.detailedCheckboxTick': {
            backgroundColor: tickWrapperColor,
            borderColor: tickWrapperColor,
            '.tick': {
              stroke: checkedColor,
              strokeDasharray: '15, 20000',
              opacity: 1
            }
          }
        };
      }

  }

  return {};
};

var DetailedCheckboxWithoutDocs = function DetailedCheckboxWithoutDocs(_ref2) {
  var _ref2$colorScheme = _ref2.colorScheme,
      colorScheme = _ref2$colorScheme === void 0 ? CheckboxColorScheme.Default : _ref2$colorScheme,
      details = _ref2.details,
      disabled = _ref2.disabled,
      error = _ref2.error,
      titleText = _ref2.titleText,
      props = _objectWithoutProperties(_ref2, _excluded);

  var dataTestProps = buildDataTestProps({
    dataTestComponent: props['data-test-component'],
    dataTestId: props['data-test-id'] || titleText
  });
  return ___EmotionJSX(WrapperLabel, dataTestProps, ___EmotionJSX(InputHidden, _extends({
    type: "checkbox"
  }, props, {
    "data-test-component": "DetailedCheckboxInput",
    "data-test-id": props.value,
    className: "stencilDetailedCheckboxHidden",
    disabled: disabled
  })), ___EmotionJSX(DetailedBox, {
    details: details,
    disabled: disabled,
    error: error,
    getInputStyles: getTickStyles,
    isInverted: colorScheme === CheckboxColorScheme.Inverted,
    titleText: titleText
  }, ___EmotionJSX(Tick, {
    className: "detailedCheckboxTick",
    colorScheme: colorScheme,
    disabled: disabled,
    error: error
  }, ___EmotionJSX(CheckboxSvg, null))));
};

var DetailedCheckboxWithDocs = describe(DetailedCheckboxWithoutDocs).description('Checkbox with more detailed and lengthy explanation');
DetailedCheckboxWithDocs.propTypes = _objectSpread(_objectSpread({}, sharedCheckboxPropTypes), {}, {
  details: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).description('Body text of the checkbox. Should be more detailed explanation of the option.'),
  disabled: PropTypes.bool.description('Prevents the user from interacting with the detailed checkbox.'),
  error: PropTypes.bool.description('Styles the detailed checkbox to indicate that the value is incorrect.'),
  titleText: PropTypes.string.isRequired.description('Title of the checkbox. Should be a short description of the option.')
});
var DetailedCheckbox = withTestAttributes({
  component: dataTestComponentName
})(DetailedCheckboxWithDocs);
DetailedCheckbox.displayName = 'DetailedCheckbox';
export default DetailedCheckbox;